import { Events } from "analytics/types";
import React, { ReactNode, useContext } from "react";

export type TrackContentModuleEngagementData = {
  event: Events;
  extra?: Record<string, unknown>;
};

type TrackContentModuleEngagementContextProps = {
  trackEngagement?(attrs: TrackContentModuleEngagementData): void;
};

export const OnboardingContext =
  React.createContext<TrackContentModuleEngagementContextProps>({
    trackEngagement: () => {},
  });

export const useTrackEngagement =
  (): TrackContentModuleEngagementContextProps =>
    useContext<TrackContentModuleEngagementContextProps>(OnboardingContext);

export function TrackContentModuleEngagementContextProvider({
  trackEngagement,
  children,
}: {
  trackEngagement(attrs?: TrackContentModuleEngagementData): void;
  children?: ReactNode;
}) {
  return (
    <OnboardingContext.Provider
      value={{
        trackEngagement,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
}
